<template>
<!-- 司机-司机在线时长 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">日期:</span>

                        <el-date-picker
                            v-model="search_time"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @change="timeChange"
                        >
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">司机电话号:</span>
                        <!-- 搜索司机电话号 -->
                        <el-input
                            v-model="search_data.phone"
                            placeholder="请输入司机电话号"
                            class="handle-input mr10"
                            @keyup.enter.native="searchDriverOnline"
                        ></el-input>
                    </el-col>
                </el-row>

                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">有效时长区间:</span>
                        <el-time-select
                            placeholder="起始时间"
                            v-model="start_time"
                            :picker-options="{
                                start: '00:00',
                                step: '00:60',
                                end: '24:00'
                            }"
                            style="width: 200px"
                            @change="timeChangeA"
                        >
                        </el-time-select>

                        <span>{{ textIsShow }}</span>
                        <el-time-select
                            placeholder="结束时间"
                            v-model="end_time"
                            :picker-options="{
                                start: '00:00',
                                step: '00:60',
                                end: '24:00'
                            }"
                            style="width: 200px"
                            @change="timeChangeB"
                        >
                        </el-time-select>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="配置区间为本城市自定义的有效在线区间，司机有效在线时长为该区间内在线总时长"
                            placement="right"
                        >
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">司机姓名:</span>
                        <!-- 搜索司机姓名 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入司机姓名"
                            class="handle-input mr10"
                            @keyup.enter.native="searchDriverOnline"
                        ></el-input>
                    </el-col>
                </el-row>
            </div>

            <el-button type="primary" icon="el-icon-search" @click="searchDriverOnline">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show"
                >{{ progress_show ? '导出中...' : '导出' }}
            </el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header" v-loading="tableLoading">
            <el-table-column label="司机姓名" prop="driver_name" min-width="130"> </el-table-column>
            <el-table-column label="司机电话号" prop="driver_phone" min-width="130"> </el-table-column>
            <el-table-column label="在线时长" prop="online_duration"></el-table-column>
            <el-table-column label="有效时长" prop="effective_duration"></el-table-column>
            <el-table-column label="单量" prop="">* </el-table-column>
            <el-table-column label="销单" prop="">* </el-table-column>
            <el-table-column label="收入" prop="">* </el-table-column>
            <el-table-column width="280px" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" trigger="click" @click="details(scope.row)"> 查看 </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 查看组件 -->
        <driverDetails
            :isShow="detail_isShow"
            :data="detailData"
            :searchTime="searchTime"
            :month="search_data.month"
            @onSubmit="searchDriverOnline"
        ></driverDetails>
    </div>
</template>

<script>
var _this;

import driverDetails from './driverDetails.vue';

export default {
    components: {
        driverDetails
    },
    data() {
        return {
            search_time: [],
            start_time: '',
            end_time: '',
            tableLoading: true,
            progress_show: false,
            searchTime: {
                start_time: '',
                end_time: ''
            },

            excelData: [],
       
            detailData: {},
            detail_isShow: false,

            // 存放表格数据
            tableData: [],

            //获取用户列表的数据
            search_data: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
                start_date: '',
                end_date: '',
                start_time: '',
                end_time: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        // 获取当前日期，用于查询条件默认本月
        _this.getCurrentMonth();
        _this.searchDriverOnline();
    },
    computed: {
        textIsShow() {
            if (_this.end_time != '' && _this.start_time != '' && _this.end_time != null && _this.start_time != null) {
                if (_this.end_time.slice(0, 2) <= _this.start_time.slice(0, 2)) {
                    return '至次日';
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    },

    methods: {
        timeChange(val) {
            console.log(val, 'val===');
            _this.search_data.start_date = val[0];
            _this.search_data.end_date = val[1];
        },

        timeChangeA(val) {
            if (val != 0 && val != null) {
                _this.search_data.start_time = val;
            } else {
                _this.search_data.start_time = '';
                _this.start_time = '';
            }

            _this.searchDriverOnline();
        },
        timeChangeB(val) {
            if (val != 0 && val != null) {
                _this.search_data.end_time = val;
            } else {
                _this.search_data.end_time = '';
                _this.end_time = '';
            }
            _this.searchDriverOnline();
        },
        getCurrentMonth() {
            // 获取当前日期
            const today = new Date();
            console.log(today,'==========');

            // 获取本月的第一天
            var start = '';
            if(today.getMonth()+1<10) {
                start = today.getFullYear()+'-'+'0'+ (today.getMonth()+1) +'-'+ '01';

            }else{

                start = today.getFullYear()+'-'+ (today.getMonth()+1) +'-'+ '01';


            }
            // const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

            // 将时间段格式化为字符串
            // const startDate = startOfMonth.toISOString().split('T')[0]; // 本月初日期
            const endDate = today.toISOString().split('T')[0]; // 当前日期

            _this.search_data.start_date = start;
            _this.search_data.end_date = endDate;
            _this.search_time[0] = start;
            _this.search_time[1] = endDate;
            // _this.search_time = ['2024-04-01','2024-04-08']; // 格式
            console.log(_this.search_time,'search_time');




            
        },
        searchDriverOnline() {
            _this.search_data.page = 1;
            _this.driverOnline();
        },
        driverOnline() {
            _this
                .$post('/driver_online/driverLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableData = res.data.list;
                    _this.start_time = res.data.start_time;
                    _this.search_data.start_time = res.data.start_time;
                    _this.end_time = res.data.end_time;
                    _this.search_data.end_time = res.data.end_time;
                    _this.tableLoading = false;

                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        toExport() {
            _this.progress_show = true;

            _this.search_data.page = 1;

            console.log(11);
            _this.getExcelData();
        },
        getExcelData() {
            console.log(22);
            _this
                .$post('/driver_online/driverLists', _this.search_data)
                .then((res) => {
                    console.log(3);

                    if (this.$route.path == '/driverOnlineTime') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {
                            _this.excelData.push({
                                driver_name: res.data.list[i].driver_name,
                                phone: res.data.list[i].driver_phone,
                                online_duration: res.data.list[i].online_duration,
                                effective_duration: res.data.list[i].effective_duration
                            });
                        }
                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page = _this.search_data.page + 1;
                            _this.getExcelData();
                        } else {
                            // 将数据导出execl
                            _this.exportData();
                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];
                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            // const tHeader = ['司机姓名',  '在线时长', '单量', '销单', '收入'];
            const tHeader = ['司机姓名', '司机电话号', '在线时长', '有效时长'];
            const filterVal = ['driver_name', 'phone', 'online_duration', 'effective_duration'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        details(val) {
            _this.detailData = val;
            console.log(_this.search_data.start_time, '_this.search_data.start_time;');
            _this.searchTime.start_time = _this.search_data.start_time;
            _this.searchTime.end_time = _this.search_data.end_time;
            _this.searchTime.start_date = _this.search_data.start_date;
            _this.searchTime.end_date = _this.search_data.end_date;
            _this.detail_isShow = !_this.detail_isShow;
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.driverOnline();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
